import * as COUNTRIES_LABELS from "./countries";
import * as ERRORS_LABELS from "./errors";
import * as GLOBAL_LABELS from "./global";

export enum SupportedLocale {
    EN_US = "en-US",
    JA_JP = "ja-JP",
    ZH_CN = "zh-CN",
    ZH_TW = "zh-TW",
    RU_RU = "ru-RU",
    TH_TH = "th-TH",
    KO_KR = "ko-KR",
}

export const LOCALE_LABELS = {
    ...COUNTRIES_LABELS,
    ...ERRORS_LABELS,
    ...GLOBAL_LABELS,
};

export const getPaymentProcessingError = (message: string) => {
    switch (message) {
        case "UnknownDevice":
            return LOCALE_LABELS.UNKNOWN_DEVICE;

        case "UnsupportedDevice":
            return LOCALE_LABELS.UNSUPPORTED_DEVICE;

        case "SecurityBreach":
            return LOCALE_LABELS.SECURITY_BREACH;

        case "LowConfidence":
            return LOCALE_LABELS.LOW_CONFIDENCE;

        case "MediumConfidence":
            return LOCALE_LABELS.MEDIUM_CONFIDENCE;

        case "HighConfidence":
            return LOCALE_LABELS.HIGH_CONFIDENCE;

        case "VeryHighConfidence":
            return LOCALE_LABELS.VERY_HIGH_CONFIDENCE;

        case "ExceededMaxChallengeAtACS":
            return LOCALE_LABELS.EXCEEDED_MAX_CHALLENGE_AT_ACS;

        case "NonPaymentTransactionsNotSupported":
            return LOCALE_LABELS.NON_PAYMENT_TRANSACTIONS_NOT_SUPPORTED;

        case "ThreeRITransactionsNotSupported":
            return LOCALE_LABELS.THREE_RI_TRANSACTIONS_NOT_SUPPORTED;

        case "TechnicalIssuesAtACS":
            return LOCALE_LABELS.TECHNICAL_ISSUES_AT_ACS;

        case "Exceeded3DSRequestorDecoupledMaxTime":
            return LOCALE_LABELS.EXCEEDED3DS_REQUESTOR_DECOUPLED_MAX_TIME;

        case "DecoupledAuthNotRequested":
            return LOCALE_LABELS.DECOUPLED_AUTH_NOT_REQUESTED;

        case "InsufficientTimeForDecoupledAuth":
            return LOCALE_LABELS.INSUFFICIENT_TIME_FOR_DECOUPLED_AUTH;

        case "AuthAttemptedButNotExecutedByCardholder":
            return LOCALE_LABELS.AUTH_ATTEMPTED_BUT_NOT_EXECUTED_BY_CARDHOLDER;

        default:
            return LOCALE_LABELS.PROCESSING_ERROR;
    }
};
